import React from 'react';
import { Text } from '@fiverr-private/typography';
import { AppI18n } from '../../../../../i18n';

export const PhoneVerificationSubtitle = () => (
    <Text size="b_sm" textAlign="center" maxWidth="450px">
        <AppI18n k="expert_card.activation.phone.subtitle" />
    </Text>
);
